import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsStack = createStackNavigator();

const NCFileDetailsNavigator = () => {
  return (
    <NCFileDetailsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsConfig.map(({ Component, name }) => (
        <NCFileDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsStack.Navigator>
  );
};

export { NCFileDetailsNavigator };
